import { FAQS, SIGNUP_URL } from '../data/mock';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

export default function FAQ() {
  return (
    <section className="section bg-slate-50/60">
      <div className="max-w-4xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <p className="chip mb-4">FAQ</p>
          <h2 className="text-3xl md:text-5xl font-extrabold tracking-tight text-slate-900">
            Frequently Asked Questions
          </h2>
          <p className="mt-4 text-slate-600">
            Everything you need to know about ACTIWA and WhatsApp marketing automation.
          </p>
        </div>

        <Accordion type="single" collapsible className="mt-10 space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`q-${i}`}
              className="bg-white border border-slate-200 rounded-2xl px-5"
            >
              <AccordionTrigger className="text-left font-semibold text-slate-900 hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-12 bg-white border border-slate-200 rounded-2xl p-8 text-center">
          <h3 className="text-xl font-bold text-slate-900">Still have questions?</h3>
          <p className="mt-2 text-slate-600">
            Can't find the answer you're looking for? Our support team is here to help.
          </p>
          <div className="mt-5 flex flex-wrap justify-center gap-3">
            <Link to="/contact">
              <Button variant="outline" className="rounded-full">Contact Support</Button>
            </Link>
            <a href={SIGNUP_URL} target="_blank" rel="noreferrer">
              <Button className="rounded-full bg-brand-purple hover:bg-brand-purple-dark text-white">Start Free Trial</Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
